/* eslint-disable no-useless-escape */
/* eslint-disable no-prototype-builtins */
import { History } from 'history';
import update from 'immutability-helper';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useCookies } from 'react-cookie';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Navigation } from '../../../global-functions';
import { agreementDisplayCheck } from '../../../hooks/agreement-hook';
import { cableLengthHook } from '../../../hooks/cable-length-hook';
import { getExistingReceivers } from '../../../hooks/exisiting-receivers-hook';
import { isMiracleEar } from '../../../hooks/miracle-ear-hook';
import { usePiTracker } from '../../../hooks/pi-tracker';
import {
    getCustomCaseName,
    getReceiverFit,
} from '../../../hooks/receiver-fit-hook';
import { useAppDispatch } from '../../../hooks/redux-hooks';
import { resetLeftCable } from '../../../hooks/reset-left-cable';
import { starkeyChoiceHook } from '../../../hooks/starkey-choice-hook';
import {
    useHandleToggleFavorite,
    useIsFavorite,
    useLoadFavorites,
} from '../../../hooks/use-is-favorite';
import { HEARING_AIDS_URL_PARAMS } from '../../../models/constants';
import { InspireTransferPatient } from '../../../models/inspire-transfer-patient';
import { IConstants, ISession } from '../../../models/pro-sites';
import {
    IAccessoryOrder,
    IAudiogramResponse,
    ICustomColor,
    IOption,
    IOrderDetails,
    IProductDetail,
    IProductHoverImage,
    IReceiverPart,
    ISelectedOptionIds,
    OptionTypes,
    receiverFitTypes,
    sides,
    StateResult,
} from '../../../models/product-detail';
import { IPatient } from '../../../models/prosites';
import { RootState } from '../../../store';
import { setIsBusy } from '../../../store/api/api-status-action';
import { addRecentlyViewedProduct } from '../../../store/e-store/wish-list-slice';
import { loadConstants } from '../../../store/externals/externals-actions';
import {
    addToCart,
    clearProductDetails,
    loadProductDetails,
} from '../../../store/product/product-detail-actions';
import { loadSession } from '../../../store/session/session-actions';
import * as CON from '../../common/constants';
import {
    BATTERY_PRODUCT_TYPE,
    CartItemTypes,
    yesNo,
} from '../../common/constants';
import RowElementWrapper from '../../common/row-element-wrapper';
import TransferPatientAlert, {
    parseTransferPatient,
} from '../../common/transfer-patient-alert';
import TextInput from '../../inputs/text-input';
import Under18Modal from './18-and-under-modal';
import CableLengthModal from './cable-length-modal';
import { ColorSection } from './color-section';
import { prepareCustomImageUrl } from './color-selector';
import EarmoldOptions from './earmold-options';
import EarmoldStyleSelection from './earmold-style-selection';
import ErrorsMessageBox from './errors-section';
import { ImageSection } from './image-section';
import ImpressionsSection from './impressions/impressions';
import LongDescription from './long-description';
import LargerStyle from './options-components/larger-style';
import StarkeyChoice from './options-components/starkey-choice';
import PatientSection from './patient-section';
import MessageModal from './popup-message-modal';
import ProductOptions from './product-options';
import ReceiverPDFGuide from './receiver-pdf-guide/receiver-pdf-guide';
import ReceiversSelect from './receivers-select';
import RelatedItemsCarousel from './related-items-carousel';
import {
    addIncludedAccessoriesDisplay,
    extractDefaultOptions,
    fetchEarmoldOptions,
    findOption,
    isAvailable,
    loadOptionsAndRules,
    parseSide,
    rulesInit,
    runEarmoldConditions,
    showHideEarmolOptionsBasedOnCROS,
} from './rules-engine';
import SavedForLaterModal from './savedForLater-modal';
import SelectButton from './select-button';
import SerialNumberLookup from './serialNumber-lookup';
import SpecialInstructions from './special-instructions';
import ThresholdSection, {
    getRoundedAudiogramValue,
} from './threshold-section';
import IsValid, { ProductOrderFormErrors } from './validation';
import WarrantySection from './warranty-section';
import Alert from '../../common/alert';

export const prepareCustomColors = (
    colors: IOption[],
    side: string | null,
    allOptions?: boolean
) => {
    const colorObject: ICustomColor[] = [];
    const createColorObject = (color: IOption) => {
        return {
            color: color.name
                .replace(/\ /gi, '-')
                .toLowerCase()
                .replace(/\-plate/gi, '')
                .replace(/\-shell/gi, '')
                .replace(/\//gi, '-')
                .replace(/\-\(gfp\)/gi, ''),
            id: color.id,
            colorName: color.english
                .replace(/\ /gi, '-')
                .toLowerCase()
                .replace(/\-plate/gi, '')
                .replace(/\-shell/gi, '')
                .replace(/\//gi, '-')
                .replace(/\-\(gfp\)/gi, ''),
            isdefault: color.isDefault!,
            swatchUrl: `/~/media/online-ordering/color%20swatches%20custom/${color.english
                .replace(/\ /gi, '-')
                .toLowerCase()
                .replace(/\-plate/gi, '')
                .replace(/\-shell/gi, '')
                .replace(/\//gi, '-')
                .replace(/\-\(gfp\)/gi, '')}.ashx`,
        };
    };
    side = parseSide(side);

    colors.forEach((x) => {
        if (allOptions) {
            colorObject.push(createColorObject(x));
        } else if (side && isAvailable(x, side)) {
            colorObject.push(createColorObject(x));
        } else if (x.isAvailableLeft && x.isAvailableRight) {
            colorObject.push(createColorObject(x));
        }
    });

    return colorObject;
};

export const getCustomColorOptions = (
    colorOptions: IOption[],
    optionType: OptionTypes
): IOption[] => {
    return colorOptions.find(
        (optionCategory) => optionCategory.id === optionType
    )!.items[0].items;
};

interface Props {
    cartId: string;
    productId: string;
    productDetails: IProductDetail | null;
    patientDetails: IPatient | null;
    agreementName: string;
    agreementInfo: string;
    patientNumberRequired: boolean;
    orderDetails: IOrderDetails | null;
    loadSession: () => Promise<void>;
    session: ISession;
    clearProductDetails: () => Promise<void>;
    loadProductDetails: (
        productGuid: string,
        cartId: string
    ) => Promise<boolean>;
    setIsBusy: (isBusy: boolean) => Promise<void>;
    receiver: IReceiverPart | null;
    constants: IConstants | null;
    loadConstants: () => Promise<void>;
    addToCart: (product: IOrderDetails) => Promise<boolean>;
    spaPath: string;
    history: History;
}

export const ProductDetail: React.FC<Props> = ({
    cartId,
    productId,
    productDetails,
    patientDetails,
    agreementName,
    agreementInfo,
    patientNumberRequired,
    orderDetails,
    loadSession,
    session,
    clearProductDetails,
    loadProductDetails,
    receiver,
    constants,
    loadConstants,
    addToCart,
    spaPath,
    history,
}) => {
    const intl = useIntl();
    const dispatch = useAppDispatch();
    const isFavorite = useIsFavorite();
    const handleToggleFavorite = useHandleToggleFavorite();

    const [cookies] = useCookies(['transferPatient']);
    const [productDetailState, setProductDetailState] =
        useState<IProductDetail>({ ...productDetails! });
    const [orderState, setOrderState] = useState<IOrderDetails>({
        ...orderDetails!,
    });
    const [errorsState, setErrorsState] = useState<ProductOrderFormErrors>({});
    const errorRef = useRef<any>(null);
    const [addingToCart, setAddingToCart] = useState<boolean>(false);
    const [productHoverImage, setProductHoverImage] =
        useState<IProductHoverImage>();
    const [showModal, setShowModal] = useState<{
        addToCart: boolean;
        saveForLater: boolean;
        under18: boolean;
        cableLength: boolean;
        isDismissedCable: boolean;
        isDismissed18: boolean;
    }>({
        addToCart: false,
        saveForLater: false,
        under18: false,
        cableLength: false,
        isDismissedCable: false,
        isDismissed18: false,
    });
    const [gainInfo, setGainInfo] = useState<IOption[] | undefined>();
    const [cableInfo, setCableInfo] = useState<IOption[] | undefined>();

    const [faceplates, setFaceplates] = useState<ICustomColor[]>([]);
    const [shells, setShells] = useState<ICustomColor[]>([]);
    const isSoundGearProduct = ['P00001866', 'P00001867', 'P00010130'].includes(
        productDetailState.partNumber
    );
    const isSoundGearTooltip = ['P00001866', 'P00001867'].includes(
        productDetailState.partNumber
    );

    useLoadFavorites();

    const prepareFaceplatesAndShells = (options: IOption[]) => {
        if (
            [CartItemTypes.CustomOnly, CartItemTypes.SoundGearCustom].includes(
                productDetailState.cartItemTypeId!
            )
        ) {
            const faceplateColors = getCustomColorOptions(
                options,
                OptionTypes.FaceplateColor
            );
            setFaceplates(
                prepareCustomColors(faceplateColors, orderState.side)
            );
        }

        const shellColors = getCustomColorOptions(
            options,
            OptionTypes.ShellColor
        );

        setShells(prepareCustomColors(shellColors, orderState.side));
    };

    const hasColorOptions = () => {
        if (productDetails === null) {
            return true;
        }
        return (
            productDetails.isCustom ||
            (productDetails.standardColors !== undefined &&
                productDetails.standardColors.length !== 0)
        );
    };

    const handleFacePlateImageHover = (hoverProduct?: IProductHoverImage) => {
        setProductHoverImage(hoverProduct);
    };

    // TODO: change this to use spread operator on patient
    const updatePatientDetails = (patientDetails: IPatient) => {
        setOrderState((prevState) => ({
            ...prevState!,
            patient: { ...prevState.patient!, ...patientDetails },
        }));
    };

    const updatePatientData = (name: string, value: any) => {
        setOrderState((prevState) => ({
            ...prevState,
            patient: { ...prevState.patient!, [name]: value },
        }));
    };

    const updateReceivers = (receiver: IReceiverPart[]) => {
        setOrderState((prevState) => ({
            ...prevState!,
            receivers: receiver,
        }));
    };

    const displayReceiverGuide =
        !isMiracleEar(session!.siteNumber) &&
        orderState!.orderType === 'bulk' &&
        productDetails!.isSnapFit2 &&
        productDetailState?.options.find(
            (option) => option.id === CON.RECEIVER_GAIN_OPTIONS_ID
        ) &&
        CON.RECEIVER_PRODUCT_GUIDE_COUNTRIES.includes(session!.country) &&
        CON.RECEIVER_PRODUCT_GUIDE_BRANDS.includes(session!.selectedBrand);

    const handleAddDeleteAccessory = (
        partNumber: string,
        quantity: number,
        isCharger?: boolean,
        chargerToDelete?: string
    ) => {
        if (!partNumber) {
            setOrderState((prevState) => ({
                ...prevState,
                accessories: orderState!.accessories.filter(
                    (accessory) => accessory.isCharger !== true
                ),
            }));
        } else {
            const chargerToAdd = {
                partNumber: partNumber,
                quantity: quantity,
                id: 3,
                isCharger: isCharger,
            };

            if (chargerToDelete) {
                const revisedAccessories = orderState!.accessories.filter(
                    (accessory) => accessory.partNumber !== chargerToDelete
                );
                setOrderState((prevState) => ({
                    ...prevState,
                    accessories: [...revisedAccessories, chargerToAdd],
                }));
            } else {
                const index = orderState!.accessories.findIndex(
                    (x) => x.partNumber === partNumber
                );
                if (quantity <= 0) {
                    setOrderState((prevState) => ({
                        ...prevState,
                        accessories: orderState!.accessories.filter(
                            (accessory) => accessory.partNumber !== partNumber
                        ),
                    }));
                } else {
                    if (index < 0) {
                        setOrderState((prevState) => ({
                            ...prevState,
                            accessories: [
                                ...orderState!.accessories,
                                chargerToAdd,
                            ],
                        }));
                    } else {
                        orderState!.accessories[index].quantity = quantity;
                        setOrderState((prevState) => ({
                            ...prevState,
                            accessories: [...orderState!.accessories],
                        }));
                    }
                }
            }
        }
    };

    const applyWfaVentLogic = (
        stateResult: StateResult | undefined,
        isEarmold: boolean
    ) => {
        // User Story 44100 vent logic...
        if (
            orderState.side === 'B' &&
            !isEarmold &&
            (orderState.isCustom ||
                (!orderState.isCustom &&
                    orderState.receiverFit === 'Absolute Power')) &&
            stateResult!.orderDetails!.useManufacturerSelect
        ) {
            const leftOptions = stateResult!.orderDetails!.leftSelectedIds;
            const rightOptions = stateResult!.orderDetails!.rightSelectedIds;
            const ventIds = [143, 144, 145, 146];
            ventIds.forEach((l) => {
                if (leftOptions!.includes(l)) {
                    ventIds.forEach((r) => {
                        if (rightOptions!.includes(r)) {
                            if (Math.abs(l - r) === 1) {
                                if (l > r) {
                                    rightOptions![rightOptions.indexOf(r)] = l;
                                } else if (r > l) {
                                    leftOptions![leftOptions.indexOf(l)] = r;
                                }
                            }
                        }
                    });
                }
            });
        }
    };

    const updateOptionsFromAudiogram = (
        orderState: IOrderDetails | undefined,
        productDetailState: IProductDetail | undefined
    ) => {
        if (orderState && productDetailState) {
            const clonedOrderState: IOrderDetails = JSON.parse(
                JSON.stringify(orderState)
            );
            let rightIds: number[];
            let leftIds: number[];
            let stateResult: StateResult = {
                orderDetails: orderState,
                productDetails: productDetailState,
            };
            if (
                ![
                    CartItemTypes.Earmold,
                    CartItemTypes.BteWithEarmold,
                    CartItemTypes.RicWithEarmold,
                    CartItemTypes.SoundGearEarmold,
                ].includes(clonedOrderState.cartItemTypeId!)
            ) {
                rightIds = clonedOrderState.rightSelectedIds
                    ? clonedOrderState.rightSelectedIds
                    : [];
                leftIds = clonedOrderState.leftSelectedIds
                    ? clonedOrderState.leftSelectedIds
                    : [];

                const starkeyChoiceOptions = productDetailState.options.find(
                    (x) => x.id === 7
                );
                if (starkeyChoiceOptions) {
                    const right = clonedOrderState.patient!.rightLoss;
                    const left = clonedOrderState.patient!.leftLoss;
                    if (
                        [
                            CartItemTypes.CustomOnly,
                            CartItemTypes.RicWithAp,
                            CartItemTypes.ApReceiver,
                        ].includes(clonedOrderState!.cartItemTypeId!)
                    ) {
                        const gainOptions = starkeyChoiceOptions.items.find(
                            (x) => x.id === 9
                        );
                        if (gainOptions) {
                            rightIds = starkeyChoiceHook(
                                gainOptions,
                                right,
                                left,
                                rightIds,
                                leftIds
                            ).rightIds;
                            leftIds = starkeyChoiceHook(
                                gainOptions,
                                right,
                                left,
                                rightIds,
                                leftIds
                            ).leftIds;
                        }
                        stateResult = runRules(
                            {
                                rightSelectedIds: rightIds,
                                leftSelectedIds: leftIds,
                            },
                            false,
                            productDetailState.options,
                            //have to pass binaural because runrules will be reading side from orderState and its not current
                            sides.binaural
                        );
                        let ventOptions = starkeyChoiceOptions.items.find(
                            (x) => x.id === 11
                        );
                        if (stateResult) {
                            rightIds =
                                stateResult.orderDetails!.rightSelectedIds;
                            leftIds = stateResult.orderDetails!.leftSelectedIds;
                            ventOptions = stateResult
                                .productDetails!.options.find(
                                    (x) => x.id === 7
                                )!
                                .items.find((x) => x.id === 11);
                        }
                        if (ventOptions) {
                            if (right && right.vent) {
                                const predictedVent = findOption(
                                    right.vent,
                                    ventOptions.items
                                );
                                if (
                                    predictedVent &&
                                    predictedVent.isAvailableRight
                                )
                                    ventOptions.items.forEach((vent) => {
                                        if (vent.english === `${right.vent}`) {
                                            if (!rightIds.includes(vent.id))
                                                rightIds.push(vent.id);
                                        } else {
                                            if (rightIds.includes(vent.id))
                                                rightIds.splice(
                                                    rightIds.indexOf(vent.id),
                                                    1
                                                );
                                        }
                                    });
                            }
                            if (left && left.vent) {
                                const predictedVent = findOption(
                                    left.vent,
                                    ventOptions.items
                                );
                                if (
                                    predictedVent &&
                                    predictedVent.isAvailableLeft
                                )
                                    ventOptions.items.forEach((vent) => {
                                        if (vent.english === `${left.vent}`) {
                                            if (!leftIds.includes(vent.id))
                                                leftIds.push(vent.id);
                                        } else {
                                            if (leftIds.includes(vent.id))
                                                leftIds.splice(
                                                    leftIds.indexOf(vent.id),
                                                    1
                                                );
                                        }
                                    });
                            }
                        }
                    }
                }

                applyWfaVentLogic(stateResult, false);

                return stateResult;
            }

            if (
                clonedOrderState!.rightEarmoldIds ||
                clonedOrderState!.leftEarmoldIds
            ) {
                const optionsAfterSyncHearingLoss = runEarmoldConditions(
                    {
                        rightSelectedIds: clonedOrderState.rightEarmoldIds
                            ? clonedOrderState.rightEarmoldIds
                            : [],
                        leftSelectedIds: clonedOrderState.leftEarmoldIds
                            ? clonedOrderState.leftEarmoldIds
                            : [],
                    },
                    productDetailState.earmoldOptions,
                    JSON.parse(JSON.stringify(orderState))
                )!.selectedOptionIds;
                stateResult = runRules(
                    {
                        rightSelectedIds:
                            optionsAfterSyncHearingLoss.rightSelectedIds,
                        leftSelectedIds:
                            optionsAfterSyncHearingLoss.leftSelectedIds,
                    },
                    true,
                    productDetailState.earmoldOptions,
                    //have to pass binaural because runrules will be reading side from orderState and its not current
                    sides.binaural
                );
                return stateResult;
            }
        }
    };

    const updateStarkeyChoiceOrHearingLoss = (
        right: IAudiogramResponse,
        left: IAudiogramResponse
    ) => {
        const stateResult = updateOptionsFromAudiogram(
            orderState,
            productDetailState
        );

        if (stateResult) {
            setOrderState((prevState) => ({
                ...prevState,
                ...stateResult.orderDetails,
            }));
            setProductDetailState((prevState) => ({
                ...prevState,
                ...stateResult.productDetails,
            }));
        }
    };
    const saveToCart = async () => {
        if (orderState && Object.keys(errorsState).length === 0) {
            setShowModal((prevState) => ({
                ...prevState,
                saveForLater: false,
            }));
            setAddingToCart(true);
            const result = await addToCart(orderState);
            if (result) {
                if (productDetailState!.existing) {
                    loadSession().then(() => {
                        Navigation.smartNavigate(
                            '/prosite/estore/cart',
                            spaPath,
                            history
                        );
                    });
                } else {
                    loadSession().then(() => {
                        setShowModal((prevState) => ({
                            ...prevState,
                            addToCart: true,
                        }));
                    });
                }
            } else {
                setAddingToCart(true);
            }
        }
    };

    const addItemToCart = async (e: React.ChangeEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (orderState) {
            const errors = IsValid(
                orderState,
                productDetailState!,
                patientNumberRequired,
                session.country,
                false,
                session.siteNumber,
                intl
            );

            if (Object.keys(errors).length === 0) {
                if (
                    session.carts.primary.length > 0 &&
                    orderState.orderType === 'patient' &&
                    !productDetailState!.existing
                ) {
                    setShowModal((prevState) => ({
                        ...prevState,
                        saveForLater: true,
                    }));
                } else {
                    saveToCart();
                }
            } else {
                setErrorsState(errors);
                window.scrollTo(0, errorRef.current);
            }
        }
    };

    const runRules = useCallback(
        (
            selectedIds: ISelectedOptionIds,
            isEarmold: boolean,
            options?: IOption[],
            side?: string | null,
            existingStateResult?: StateResult
        ): StateResult => {
            const currentSide = parseSide(side || orderState.side || 'B');
            const stateResult: StateResult = existingStateResult
                ? existingStateResult
                : {
                      productDetails: {} as any,
                      orderDetails: {} as any,
                  };

            if (!options || options.length <= 0) {
                if (isEarmold) {
                    // productDetails
                    stateResult.productDetails!.earmoldOptions = [];
                    // orderDetails
                    stateResult.orderDetails!.rightEarmoldIds = [];
                    stateResult.orderDetails!.leftEarmoldIds = [];
                } else {
                    // productDetails
                    stateResult.productDetails!.options = [];
                    // orderDetails;
                    stateResult.orderDetails!.rightSelectedIds = [];
                    stateResult.orderDetails!.leftSelectedIds = [];
                    stateResult.orderDetails!.useManufacturerSelect = true;
                }

                return stateResult;
            }

            const firstRun =
                selectedIds.rightSelectedIds.length === 0 &&
                selectedIds.leftSelectedIds.length === 0;

            const defaultOptions: any = {};
            let updatedSelectedIds: ISelectedOptionIds = JSON.parse(
                JSON.stringify(selectedIds)
            );

            if (
                currentSide !== sides.left &&
                selectedIds.rightSelectedIds.length === 0
            ) {
                [sides.right].forEach((x) =>
                    extractDefaultOptions(
                        { ...defaultOptions, items: options! },
                        x,
                        updatedSelectedIds,
                        false
                    )
                );
                [sides.right].forEach((x) =>
                    addIncludedAccessoriesDisplay(
                        { ...defaultOptions, items: options! },
                        x,
                        updatedSelectedIds
                    )
                );
            }

            if (
                currentSide !== sides.right &&
                selectedIds.leftSelectedIds.length === 0
            ) {
                [sides.left].forEach((x) =>
                    extractDefaultOptions(
                        { ...defaultOptions, items: options! },
                        x,
                        updatedSelectedIds,
                        false
                    )
                );
                [sides.left].forEach((x) =>
                    addIncludedAccessoriesDisplay(
                        { ...defaultOptions, items: options! },
                        x,
                        updatedSelectedIds
                    )
                );
            }

            if (currentSide === sides.right && !orderState.cros) {
                updatedSelectedIds = {
                    rightSelectedIds: updatedSelectedIds.rightSelectedIds,
                    leftSelectedIds: updatedSelectedIds.rightSelectedIds,
                };
            }

            if (currentSide === sides.left && !orderState.cros) {
                updatedSelectedIds = {
                    rightSelectedIds: updatedSelectedIds.leftSelectedIds,
                    leftSelectedIds: updatedSelectedIds.leftSelectedIds,
                };
            }

            const optionsState: IOption[] = JSON.parse(JSON.stringify(options));

            if (firstRun && isEarmold) {
                updatedSelectedIds = showHideEarmolOptionsBasedOnCROS(
                    orderState,
                    updatedSelectedIds
                );
            }

            let rulesResult = rulesInit(
                optionsState,
                updatedSelectedIds,
                isEarmold,
                {
                    rightSelectedIds: isEarmold
                        ? orderState!.rightEarmoldIds && !firstRun
                            ? JSON.parse(
                                  JSON.stringify(orderState!.rightEarmoldIds)
                              )
                            : []
                        : orderState!.rightSelectedIds
                        ? JSON.parse(
                              JSON.stringify(orderState!.rightSelectedIds)
                          )
                        : [],
                    leftSelectedIds: isEarmold
                        ? orderState!.leftEarmoldIds && !firstRun
                            ? JSON.parse(
                                  JSON.stringify(orderState!.leftEarmoldIds)
                              )
                            : []
                        : orderState!.leftSelectedIds
                        ? JSON.parse(
                              JSON.stringify(orderState!.leftSelectedIds)
                          )
                        : [],
                },
                currentSide === sides.binaural
                    ? [sides.right, sides.left]
                    : currentSide === sides.right
                    ? [sides.right]
                    : [sides.left]
            );

            if (firstRun && isEarmold) {
                rulesResult = runEarmoldConditions(
                    rulesResult!.selectedOptionIds,
                    rulesResult!.options,
                    JSON.parse(JSON.stringify(orderState))
                );
            }

            if (rulesResult) {
                if (isEarmold) {
                    // productDetails
                    stateResult.productDetails!.earmoldOptions =
                        rulesResult.options;
                    // orderDetails
                    stateResult.orderDetails!.earmoldOptions =
                        rulesResult.options;
                    stateResult.orderDetails!.rightEarmoldIds =
                        rulesResult.selectedOptionIds.rightSelectedIds;
                    stateResult.orderDetails!.leftEarmoldIds =
                        rulesResult.selectedOptionIds.leftSelectedIds;
                } else {
                    // productDetails
                    stateResult.productDetails!.options = rulesResult.options;
                    // orderDetails
                    stateResult.orderDetails!.productOptions =
                        rulesResult.options;
                    stateResult.orderDetails!.rightSelectedIds =
                        rulesResult.selectedOptionIds.rightSelectedIds;
                    stateResult.orderDetails!.leftSelectedIds =
                        rulesResult.selectedOptionIds.leftSelectedIds;
                    stateResult.orderDetails!.useManufacturerSelect =
                        rulesResult!.selectedOptionIds.rightSelectedIds.includes(
                            782
                        ) &&
                        rulesResult!.selectedOptionIds.leftSelectedIds.includes(
                            782
                        );
                }
            }

            return stateResult;
        },
        [orderState]
    );

    // TODO: change signature to take state result and include other props in state - will also run rules if required.
    const handleOptionsChange = (
        rightSelectedIds: number[],
        leftSelectedIds: number[],
        isEarmold = false,
        earmoldOptionsLoad?: IOption[] | null
    ) => {
        const selectedIds: ISelectedOptionIds = {
            rightSelectedIds: rightSelectedIds ? rightSelectedIds : [],
            leftSelectedIds: leftSelectedIds ? leftSelectedIds : [],
        };

        const stateResult = runRules(
            selectedIds,
            isEarmold,
            isEarmold
                ? earmoldOptionsLoad === undefined
                    ? productDetailState!.earmoldOptions
                    : earmoldOptionsLoad === null
                    ? undefined
                    : earmoldOptionsLoad
                : productDetailState!.options
        );

        applyWfaVentLogic(stateResult, false);

        setProductDetailState((prevState) => ({
            ...prevState,
            ...stateResult.productDetails!,
        }));

        setOrderState((prevState) => ({
            ...prevState,
            ...stateResult.orderDetails!,
        }));
    };
    const handleEarmoldDesignIdChange = async (earmoldDesignId?: number) => {
        if (earmoldDesignId && !isNaN(earmoldDesignId)) {
            const earmoldOptions = await fetchEarmoldOptions(
                session!.catalog,
                earmoldDesignId,
                session!,
                productDetails!
            );

            handleOptionsChange([], [], true, earmoldOptions);
            setOrderState((prevState) => ({
                ...prevState,
                earmoldDesignId: earmoldDesignId,
            }));
        } else {
            handleOptionsChange([], [], true);
            setOrderState((prevState) => ({
                ...prevState,
                earmoldDesignId: undefined,
            }));
        }
    };

    const handleOrderTypeChange = (orderType: string) => {
        //running rules to reset CROS selection bug 31861
        const stateresult = runRules(
            { rightSelectedIds: [], leftSelectedIds: [] },
            false,
            getOptions(productDetailState.cartItemTypeId!)
        );

        if (orderType === 'patient') {
            setOrderState((prevState) => ({
                ...prevState!,
                orderType: orderType,
                side: 'B',
                ampQuantityLeft: 1,
                receiverFit: receiverFitTypes.standard,
                receivers: orderState.additionalReceivers
                    ? [
                          {
                              ...receiver!,
                              useAngledParts: true,
                              quantity: 1,
                          },
                      ]
                    : null,
                patient: {
                    ...prevState!.patient!,
                    audiogram: prevState!.patient!.audiogram,
                },
                accessories: setRelatedItemQuantityForPatientOrders(
                    prevState!.accessories
                ),
                ...stateresult.orderDetails,
            }));
        } else {
            setOrderState((prevState) => ({
                ...prevState!,
                additionalReceivers: false,
                orderType: orderType,
                isStockOrder: orderType,
                quantity: 1,
                ampQuantityLeft: 0,
                cartItemTypeId:
                    prevState!.cartItemTypeId === CartItemTypes.BteWithEarmold
                        ? CartItemTypes.BteOnly
                        : [
                              CartItemTypes.RicWithEarmold,
                              CartItemTypes.RicWithAp,
                          ].includes(prevState!.cartItemTypeId!)
                        ? CartItemTypes.RicWithStockReceiver
                        : prevState!.cartItemTypeId!,
                receiverFit: receiverFitTypes.standard,
                side: null,
                receivers: [CartItemTypes.RicWithStockReceiver].includes(
                    productDetailState!.cartItemTypeId!
                )
                    ? [
                          {
                              ...receiver!,
                              useAngledParts: true,
                              quantity: 1,
                          },
                      ]
                    : null,
                warranty: 0,
                ...stateresult.orderDetails,
            }));
        }

        const standardFaceplates = findOption(
            5,
            stateresult.productDetails!.options
        );
        ///making the selected color stick when receiverfit is changed
        if (standardFaceplates && stateresult) {
            const rightOptions = stateresult.orderDetails!.rightSelectedIds;
            const leftOptions = stateresult.orderDetails!.leftSelectedIds;
            standardFaceplates.items.forEach((x) => {
                if (rightOptions.includes(x.id)) {
                    rightOptions.splice(rightOptions.indexOf(x.id), 1);
                }
                if (leftOptions.includes(x.id)) {
                    leftOptions.splice(leftOptions.indexOf(x.id), 1);
                }
            });
            rightOptions.push(
                standardFaceplates.items.find(
                    (x) => x.english === productDetailState.color
                )!.id
            );
            leftOptions.push(
                standardFaceplates.items.find(
                    (x) => x.english === productDetailState.color
                )!.id
            );
        }

        setProductDetailState((prevState) => ({
            ...prevState,
            ...stateresult.productDetails,
        }));
    };

    const setRelatedItemQuantityForPatientOrders = (
        accessories: IAccessoryOrder[]
    ) => {
        const selectedChargersCount = accessories.filter(
            (accessory) =>
                accessory.isCharger ||
                accessory.productType === BATTERY_PRODUCT_TYPE
        ).length;
        const setQuantity = (accessory: IAccessoryOrder) => {
            const temp = Object.assign({}, accessory);
            if (temp.quantity > 1) {
                temp.quantity = 1;
            }
            return temp;
        };

        if (selectedChargersCount > 1) {
            return accessories
                .filter(
                    (accessory) =>
                        !accessory.isCharger &&
                        accessory.productType !== BATTERY_PRODUCT_TYPE
                )
                .map(setQuantity);
        } else {
            return accessories.map(setQuantity);
        }
    };

    const handleSideChange = (side: string) => {
        ///resetting selections if it is CROS
        let stateResult = runRules(
            {
                rightSelectedIds: orderState.cros
                    ? []
                    : orderState.side !== 'L'
                    ? orderState.rightSelectedIds
                    : orderState.leftSelectedIds,
                leftSelectedIds: orderState.cros
                    ? []
                    : orderState.side !== 'R'
                    ? orderState.leftSelectedIds
                    : orderState.rightSelectedIds,
            },
            false,
            productDetailState.options,
            side
        );

        const temp = updateOptionsFromAudiogram(
            { ...orderState, ...stateResult.orderDetails },
            { ...productDetailState, ...stateResult.productDetails }
        );

        if (temp) {
            stateResult = {
                ...stateResult,
                orderDetails: {
                    ...stateResult.orderDetails!,
                    rightSelectedIds:
                        temp.orderDetails!.rightSelectedIds ||
                        stateResult.orderDetails!.rightSelectedIds,
                    leftSelectedIds:
                        temp.orderDetails!.leftSelectedIds ||
                        stateResult.orderDetails!.leftSelectedIds,
                    rightEarmoldIds: temp.orderDetails!.rightEarmoldIds,
                    leftEarmoldIds: temp.orderDetails!.leftEarmoldIds,
                },
            };
        }

        if (
            [
                CartItemTypes.BteWithEarmold,
                CartItemTypes.RicWithEarmold,
                CartItemTypes.Earmold,
                CartItemTypes.SoundGearEarmold,
            ].includes(orderState.cartItemTypeId!) &&
            !orderState.cros
        ) {
            stateResult = runRules(
                {
                    rightSelectedIds:
                        orderState.side !== 'L'
                            ? orderState.rightEarmoldIds
                            : orderState.leftEarmoldIds,
                    leftSelectedIds:
                        orderState.side !== 'R'
                            ? orderState.leftEarmoldIds
                            : orderState.rightEarmoldIds,
                },
                true,
                productDetailState.earmoldOptions,
                side === 'B'
                    ? sides.binaural
                    : side === 'R'
                    ? sides.right
                    : sides.left,
                stateResult
            );

            const temp = updateOptionsFromAudiogram(
                { ...orderState, ...stateResult.orderDetails },
                { ...productDetailState, ...stateResult.productDetails }
            );

            if (temp) {
                stateResult = {
                    ...stateResult,
                    orderDetails: {
                        ...stateResult.orderDetails!,
                        rightSelectedIds:
                            temp.orderDetails!.rightSelectedIds ||
                            stateResult.orderDetails!.rightSelectedIds,
                        leftSelectedIds:
                            temp.orderDetails!.leftSelectedIds ||
                            stateResult.orderDetails!.leftSelectedIds,
                        rightEarmoldIds: temp.orderDetails!.rightEarmoldIds,
                        leftEarmoldIds: temp.orderDetails!.leftEarmoldIds,
                    },
                };
            }
        } else {
            ///resetting earmold options when side changes as per old site
            stateResult = {
                ...stateResult,
                orderDetails: {
                    ...stateResult.orderDetails!,
                    showEarmoldForMonauralCros: undefined,
                    rightEarmoldIds: [],
                    leftEarmoldIds: [],
                    earmoldDesignId: undefined,
                },
                productDetails: {
                    ...stateResult.productDetails!,
                    earmoldOptions: [],
                },
            };
        }

        const standardFaceplates = findOption(
            5,
            stateResult.productDetails!.options
        );
        //making the selected color stick when side is changed
        if (standardFaceplates && stateResult) {
            const rightOptions =
                stateResult.orderDetails!.rightSelectedIds || [];
            const leftOptions = stateResult.orderDetails!.leftSelectedIds || [];
            standardFaceplates.items.forEach((x) => {
                if (rightOptions.includes(x.id)) {
                    rightOptions.splice(rightOptions.indexOf(x.id), 1);
                }
                if (leftOptions.includes(x.id)) {
                    leftOptions.splice(leftOptions.indexOf(x.id), 1);
                }
            });
            const rightStdFaceplates = standardFaceplates.items.find(
                (x) =>
                    x.name === productDetailState.color ||
                    orderState.rightSelectedIds.includes(x.id)
            );
            if (rightStdFaceplates) {
                rightOptions.push(rightStdFaceplates.id);
            }
            const leftStdFaceplates = standardFaceplates.items.find(
                (x) =>
                    x.name === productDetailState.color ||
                    orderState.leftSelectedIds.includes(x.id)
            );
            if (leftStdFaceplates) {
                leftOptions.push(leftStdFaceplates.id);
            }
        }

        // Bug 34089 - When side is set to left or right, only the receiver with that side should have a quantity > 0.
        // Server-side code then drops 0-quantity receiver(s) from the collection when updating cart.
        if (orderState!.receivers && side !== 'B') {
            orderState.receivers.forEach((x) => {
                if (x.side !== side) {
                    x.quantity = 0;
                }
            });

            stateResult = {
                ...stateResult,
                orderDetails: {
                    ...stateResult.orderDetails!,
                    receivers: orderState.receivers,
                },
            };
        }

        setOrderState((prevState) => ({
            ...prevState,
            ...stateResult.orderDetails,
            side: side,
            pairAid: null,
        }));

        setProductDetailState((prevState) => ({
            ...prevState,
            ...stateResult.productDetails,
        }));
    };

    const handleReceiverFitChange = (receiverFit: string) => {
        const cloned: IProductDetail = JSON.parse(
            JSON.stringify(productDetailState)
        );
        cloned.cartItemTypeId = getCartItemTypeID(receiverFit);
        let stateresult = runRules(
            { rightSelectedIds: [], leftSelectedIds: [] },
            false,
            getOptions(cloned.cartItemTypeId!)
        );

        const od = {
            ...orderState,
            cartItemTypeId: getCartItemTypeID(receiverFit),
            ...stateresult.orderDetails,
        };
        const pd = { ...productDetailState, ...stateresult.productDetails };

        const temp = updateOptionsFromAudiogram(od, pd);

        if (temp) {
            stateresult = {
                ...stateresult,
                orderDetails: {
                    ...stateresult.orderDetails!,
                    rightSelectedIds:
                        temp.orderDetails!.rightSelectedIds ||
                        stateresult.orderDetails!.rightSelectedIds,
                    leftSelectedIds:
                        temp.orderDetails!.leftSelectedIds ||
                        stateresult.orderDetails!.leftSelectedIds,
                    rightEarmoldIds: temp.orderDetails!.rightEarmoldIds,
                    leftEarmoldIds: temp.orderDetails!.leftEarmoldIds,
                },
            };
        }

        const standardFaceplates = findOption(
            5,
            stateresult.productDetails!.options
        );
        ///making the selected color stick when receiverfit is changed
        if (standardFaceplates && stateresult) {
            const rightOptions =
                stateresult.orderDetails!.rightSelectedIds || [];
            const leftOptions = stateresult.orderDetails!.leftSelectedIds || [];
            standardFaceplates.items.forEach((x) => {
                if (rightOptions.includes(x.id)) {
                    rightOptions.splice(rightOptions.indexOf(x.id), 1);
                }
                if (leftOptions.includes(x.id)) {
                    leftOptions.splice(leftOptions.indexOf(x.id), 1);
                }
            });
            rightOptions.push(
                standardFaceplates.items.find(
                    (x) => x.name === productDetailState.color
                )!.id
            );
            leftOptions.push(
                standardFaceplates.items.find(
                    (x) => x.name === productDetailState.color
                )!.id
            );
        }

        ////resetting options and selections when receiver fit is changed
        setOrderState((prevState) => ({
            ...prevState,
            ...stateresult!.orderDetails,
            additionalReceivers:
                receiverFit !== receiverFitTypes.standard && false,
            receiverFit: receiverFit,
            earmoldDesignId: undefined,
            showEarmoldForMonauralCros: undefined,
            cartItemTypeId: getCartItemTypeID(receiverFit),
        }));
        setProductDetailState((prevState) => ({
            ...prevState,
            ...stateresult!.productDetails,
            earmoldOptions: [],
        }));
    };

    const handleCrosEarmoldQuestion = (isEarmoldForCros: boolean) => {
        setOrderState((prevState) => ({
            ...prevState,
            showEarmoldForMonauralCros: isEarmoldForCros,
            earmoldDesignId: undefined,
            rightEarmoldIds: [],
            leftEarmoldIds: [],
        }));

        setProductDetailState((prevState) => ({
            ...prevState,
            earmoldOptions: [],
        }));
    };

    const handleStateResultChange = (stateResult: StateResult) => {
        const ruleTriggerKeys = ['rightSelectedIds'];

        const isEarmold = Boolean(stateResult.isEarmold);
        let ruleResult: StateResult = {};

        if (
            stateResult.orderDetails &&
            ruleTriggerKeys.some((k) =>
                stateResult.orderDetails!.hasOwnProperty(k)
            )
        ) {
            ruleResult = runRules(
                {
                    rightSelectedIds: stateResult.orderDetails.rightSelectedIds
                        ? stateResult.orderDetails.rightSelectedIds
                        : [],
                    leftSelectedIds: stateResult.orderDetails.leftSelectedIds
                        ? stateResult.orderDetails.leftSelectedIds
                        : [],
                },
                isEarmold,
                productDetailState!.options
            );
        }

        if (
            isEarmold &&
            stateResult.orderDetails &&
            stateResult.orderDetails.hasOwnProperty('rightSelectedIds')
        ) {
            stateResult.orderDetails.rightEarmoldIds =
                stateResult.orderDetails.rightSelectedIds;
            stateResult.orderDetails.leftEarmoldIds =
                stateResult.orderDetails.leftSelectedIds;

            stateResult.orderDetails.rightSelectedIds = [];
            stateResult.orderDetails.leftSelectedIds = [];
        }

        setProductDetailState((prevState) => ({
            ...prevState,
            ...stateResult.productDetails!,
            ...ruleResult.productDetails!,
        }));

        setOrderState((prevState) => ({
            ...prevState,
            ...stateResult.orderDetails!,
            ...ruleResult.orderDetails!,
        }));
    };
    const handleAdditionalReceivers = (value: boolean) => {
        setOrderState((prevState) => ({
            ...prevState,
            receivers: value
                ? [
                      {
                          ...receiver!,
                          useAngledParts: true,
                          quantity: 1,
                      },
                  ]
                : null,
            additionalReceivers: value,
        }));
    };
    const handleChange = (name: string, value: any) => {
        if (name === 'stateResult') {
            handleStateResultChange(value);
        } else {
            switch (name) {
                case 'orderType':
                    handleOrderTypeChange(value);
                    break;
                case 'side':
                    handleSideChange(value);
                    break;
                case 'receiverFit':
                    handleReceiverFitChange(value);
                    break;
                case 'earmoldDesignId':
                    handleEarmoldDesignIdChange(value);
                    break;
                case 'earmoldForCros':
                    handleCrosEarmoldQuestion(value);
                    break;
                case 'additionalReceivers':
                    handleAdditionalReceivers(value);
                    break;
                default:
                    setOrderState((prevState) => ({
                        ...prevState,
                        [name]: value,
                    }));
                    break;
            }
        }
    };

    const getCartItemTypeID = (fitType: string) => {
        switch (fitType) {
            case receiverFitTypes.standard:
                if (
                    productDetailState!.cartItemTypeId === CartItemTypes.BteOnly
                ) {
                    return CartItemTypes.BteOnly;
                }
                if (
                    productDetailState!.cartItemTypeId ===
                    CartItemTypes.RicWithStockReceiver
                ) {
                    return CartItemTypes.RicWithStockReceiver;
                }
                break;

            case receiverFitTypes.earmold:
                if (
                    productDetailState!.cartItemTypeId === CartItemTypes.BteOnly
                ) {
                    return CartItemTypes.BteWithEarmold;
                }
                if (
                    productDetailState!.cartItemTypeId ===
                    CartItemTypes.RicWithStockReceiver
                ) {
                    return CartItemTypes.RicWithEarmold;
                }

                break;

            case receiverFitTypes.ap:
                if (
                    productDetailState!.cartItemTypeId ===
                    CartItemTypes.RicWithStockReceiver
                ) {
                    return CartItemTypes.RicWithAp;
                }

                break;

            default:
                break;
        }
    };

    // Note if the service just returned options on one property this wouldn't be necessary.
    const getOptions = (cartItemTypeId: number): IOption[] => {
        switch (cartItemTypeId) {
            case CartItemTypes.RicWithEarmold:
                return loadOptionsAndRules(productDetails!.ricEarmoldOptions);
            case CartItemTypes.RicWithAp:
                return loadOptionsAndRules(productDetails!.ricAPOptions);
            case CartItemTypes.BteWithEarmold:
                return loadOptionsAndRules(productDetails!.bteEarmoldOptions);
            default:
                return loadOptionsAndRules(productDetails!.options);
        }
    };

    const getInitialPatient = (
        transferPatient: InspireTransferPatient | undefined,
        patientDetails: IPatient | null,
        isAgreementOrder: boolean
    ): any => {
        const audiogramAsserter = function (x: any) {
            return ((x || '') + ',,,,,,,,,').split(',').slice(0, 10).join(',');
        };
        const speechRounder = function (x: string | undefined) {
            if (!x) return x;
            const parsed = parseInt(x);
            if (!parsed) return x;
            return `${getRoundedAudiogramValue(parsed)}`;
        };
        return transferPatient
            ? {
                  ageRange: transferPatient.ageRange,
                  firstName: transferPatient.firstName,
                  lastName: isMiracleEar(session.siteNumber)
                      ? null
                      : transferPatient.lastName,
                  agreement: isAgreementOrder,
                  agreementType: agreementName,
                  agreementInfo: agreementInfo,
                  audiogram: JSON.stringify(
                      transferPatient.audiogram
                          ? update(
                                {
                                    ...transferPatient.audiogram,
                                },
                                {
                                    right: {
                                        air: {
                                            curve: {
                                                $apply: audiogramAsserter,
                                            },
                                        },
                                        bone: {
                                            curve: {
                                                $apply: audiogramAsserter,
                                            },
                                        },
                                        MCL: {
                                            $apply: speechRounder,
                                        },
                                        UCL: {
                                            $apply: speechRounder,
                                        },
                                    },
                                    left: {
                                        air: {
                                            curve: {
                                                $apply: audiogramAsserter,
                                            },
                                        },
                                        bone: {
                                            curve: {
                                                $apply: audiogramAsserter,
                                            },
                                        },
                                        MCL: {
                                            $apply: speechRounder,
                                        },
                                        UCL: {
                                            $apply: speechRounder,
                                        },
                                    },
                                    MCL: {
                                        $apply: speechRounder,
                                    },
                                    UCL: {
                                        $apply: speechRounder,
                                    },
                                }
                            )
                          : {
                                right: {
                                    air: { curve: ',,,,,,,,,' },
                                    bone: { curve: ',,,,,,,,,' },
                                    MCL: null,
                                    UCL: null,
                                },
                                left: {
                                    air: { curve: ',,,,,,,,,' },
                                    bone: { curve: ',,,,,,,,,' },
                                    MCL: null,
                                    UCL: null,
                                },
                                MCL: null,
                                UCL: null,
                            }
                  ),
              }
            : {
                  ...patientDetails!,
                  agreement: isAgreementOrder,
                  agreementType: agreementName,
                  agreementInfo: agreementInfo,
                  audiogram: JSON.stringify({
                      right: {
                          air: { curve: ',,,,,,,,,' },
                          bone: { curve: ',,,,,,,,,' },
                          MCL: null,
                          UCL: null,
                      },
                      left: {
                          air: { curve: ',,,,,,,,,' },
                          bone: { curve: ',,,,,,,,,' },
                          MCL: null,
                          UCL: null,
                      },
                      MCL: null,
                      UCL: null,
                  }),
              };
    };

    const getInitialOrderType = (
        hasTransferPatient: boolean,
        isAgreementOrder: boolean
    ): string => {
        return (hasTransferPatient &&
            [
                CartItemTypes.BteOnly,
                CartItemTypes.RicWithStockReceiver,
                CartItemTypes.CustomOnly,
                CartItemTypes.Earmold,
                CartItemTypes.BteWithEarmold,
                CartItemTypes.RicWithEarmold,
                CartItemTypes.ApReceiver,
                CartItemTypes.RicWithAp,
                CartItemTypes.RicWithChr,
            ].includes(productDetails!.cartItemTypeId!)) ||
            isAgreementOrder ||
            [
                CartItemTypes.CustomOnly,
                CartItemTypes.Earmold,
                CartItemTypes.SoundGearEarmold,
                CartItemTypes.SoundGearCustom,
                CartItemTypes.ApReceiver,
            ].includes(productDetails!.cartItemTypeId!) ||
            isMiracleEar(session.siteNumber)
            ? 'patient'
            : 'bulk';
    };

    const getExistingCrosPairAid = () => {
        if (productDetails && productDetails.crosHearingAidTechnologies) {
            const selectedLeft = productDetails.existing.leftOptions.some(
                (x) => x === 511
            );
            const selectedRight = productDetails.existing.rightOptions.some(
                (x) => x === 511
            );
            let desc: string | undefined;
            if (
                selectedLeft &&
                productDetails.existing.side &&
                productDetails.existing.side.toLowerCase() === sides.binaural
            ) {
                desc = productDetails.existingPairAidDescription;
            } else if (selectedRight || selectedLeft) {
                desc = productDetails.existing.description;
            }
            if (desc) {
                return (
                    productDetails.crosHearingAidTechnologies.find(
                        (x) => x.description === desc
                    ) || null
                );
            }
        }
        return null;
    };

    const hasLargerStyle = (): boolean => {
        const starkeyChoice = findOption(
            'Starkey Choice',
            productDetailState!.options
        );
        if (starkeyChoice && starkeyChoice.items) {
            const manufacturerSelect = findOption(
                'Manufacturer Select',
                starkeyChoice.items
            );
            if (manufacturerSelect && manufacturerSelect.items) {
                const largerStyle = findOption(
                    CON.LARGER_STYLE_ID,
                    manufacturerSelect.items
                );
                if (largerStyle) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    };
    //#region UseEffects
    usePiTracker();

    useEffect(() => {
        if (!constants) {
            loadConstants();
        }
        return () => {
            clearProductDetails();
        };
    }, [constants]);

    useEffect(() => {
        loadProductDetails(productId, cartId);
        if (!cartId || cartId === '') {
            dispatch(addRecentlyViewedProduct(productId));
        }
    }, [cartId, productId]);

    useEffect(() => {
        if (productDetails) {
            document.title = productDetails.description; // TODO: move to use component

            const cloned: IProductDetail = JSON.parse(
                JSON.stringify(productDetails)
            );

            let stateResult: StateResult = {
                productDetails: {} as IProductDetail,
                orderDetails: {} as IOrderDetails,
            };

            if (!cloned.existing) {
                const selectedIds: ISelectedOptionIds = {
                    rightSelectedIds: [],
                    leftSelectedIds: [],
                };

                stateResult = runRules(
                    selectedIds,
                    false,
                    getOptions(productDetails.cartItemTypeId!)
                );
            }

            if (cloned.existing) {
                ///setting options from existing product
                stateResult.productDetails!.options = cloned.existing
                    .productOptions
                    ? cloned.existing.productOptions
                    : [];
                stateResult.productDetails!.earmoldOptions = cloned.existing
                    .earmoldOptions
                    ? cloned.existing.earmoldOptions
                    : [];

                ///setting options selection from existing product
                stateResult.orderDetails!.rightSelectedIds = cloned.existing
                    .rightOptions
                    ? cloned.existing.rightOptions
                    : [];
                stateResult.orderDetails!.leftSelectedIds = cloned.existing
                    .leftOptions
                    ? resetLeftCable(cloned.existing.leftOptions)
                    : [];
                stateResult.orderDetails!.rightEarmoldIds = [
                    CartItemTypes.Earmold,
                ].includes(cloned.existing.cartItemTypeId!)
                    ? cloned.existing.rightOptions
                        ? cloned.existing.rightOptions
                        : []
                    : cloned.existing.rightEarmoldIds
                    ? cloned.existing.rightEarmoldIds
                    : [];
                stateResult.orderDetails!.leftEarmoldIds = [
                    CartItemTypes.Earmold,
                ].includes(cloned.existing.cartItemTypeId!)
                    ? cloned.existing.leftOptions
                        ? cloned.existing.leftOptions
                        : []
                    : cloned.existing.leftEarmoldIds
                    ? resetLeftCable(cloned.existing.leftEarmoldIds)
                    : [];

                ///setting options on orderState from existing product
                stateResult.orderDetails!.productOptions = cloned.existing
                    .productOptions
                    ? cloned.existing.productOptions
                    : [];
                stateResult.orderDetails!.earmoldOptions = cloned.existing
                    .earmoldOptions
                    ? cloned.existing.earmoldOptions
                    : [];
            }

            let customDefaultImageUrl: string | undefined;

            if (
                productDetails.isCustom &&
                cloned.cartItemTypeId !== CartItemTypes.Earmold &&
                stateResult.orderDetails &&
                stateResult.productDetails
            ) {
                let faceplateColors: IOption[] = [];
                if (
                    [
                        CartItemTypes.CustomOnly,
                        CartItemTypes.SoundGearCustom,
                    ].includes(productDetails.cartItemTypeId!)
                ) {
                    faceplateColors = getCustomColorOptions(
                        stateResult.productDetails.options,
                        OptionTypes.FaceplateColor
                    );
                }

                const shellColors = getCustomColorOptions(
                    stateResult.productDetails.options,
                    OptionTypes.ShellColor
                );

                const shell = shellColors.find(
                    (x) =>
                        (cloned.existing &&
                            cloned.existing.side !== 'Left' &&
                            stateResult.orderDetails!.rightSelectedIds.includes(
                                x.id
                            )) ||
                        stateResult.orderDetails!.rightSelectedIds.includes(
                            x.id
                        ) ||
                        (cloned.existing &&
                            cloned.existing!.side !== 'Right' &&
                            stateResult.orderDetails!.leftSelectedIds.includes(
                                x.id
                            )) ||
                        stateResult.orderDetails!.leftSelectedIds.includes(x.id)
                );
                const faceplate = faceplateColors.find(
                    (x) =>
                        (cloned.existing &&
                            cloned.existing.side !== 'Left' &&
                            stateResult.orderDetails!.rightSelectedIds.includes(
                                x.id
                            )) ||
                        stateResult.orderDetails!.rightSelectedIds.includes(
                            x.id
                        ) ||
                        (cloned.existing &&
                            cloned.existing!.side !== 'Right' &&
                            stateResult.orderDetails!.leftSelectedIds.includes(
                                x.id
                            )) ||
                        stateResult.orderDetails!.leftSelectedIds.includes(x.id)
                );

                if (shell) {
                    stateResult.productDetails!.shellColor = shell!.english;
                }

                if (faceplate) {
                    stateResult.productDetails!.faceplateColor =
                        faceplate!.english;
                }

                const faceplateObjects = prepareCustomColors(
                    faceplateColors,
                    orderState.side
                );
                const shellObjects = prepareCustomColors(
                    shellColors,
                    orderState.side
                );

                customDefaultImageUrl = prepareCustomImageUrl(
                    productDetails.imageBase,
                    faceplateObjects,
                    shellObjects,
                    faceplate
                        ? faceplateObjects.find((x) => x.id === faceplate.id)
                        : undefined,
                    shell
                        ? shellObjects.find((x) => x.id === shell.id)
                        : undefined
                );
            }

            const newProductDetailState = {
                longDescription: [CartItemTypes.ApReceiver].includes(
                    cloned.cartItemTypeId!
                )
                    ? productDetails.compatibility
                    : productDetails.longDescription,
                color: productDetails.existing
                    ? productDetails.existing.color
                    : productDetails.defaultColor,
                imageUrl: productDetails.existing
                    ? productDetails.existing.imageUrl
                    : customDefaultImageUrl || productDetails.imageUrl,
                imageBase: productDetails.imageBase,
                standardColors: productDetails.standardColors,
                isCros:
                    productDetails!.cros ||
                    CON.APIDs.some((x) => {
                        return findOption(x, productDetails!.options)
                            ? true
                            : false;
                    }),
                existing: productDetails.existing,
            };

            setProductDetailState({
                ...cloned,
                ...newProductDetailState,
                ...stateResult.productDetails!,
            });

            if (productDetails.isCustom && stateResult.productDetails) {
                prepareFaceplatesAndShells(stateResult.productDetails.options);
            }

            if (productDetails.existing) {
                setOrderState({
                    ...orderState!,
                    additionalReceivers: productDetails.existing.receivers
                        ? productDetails.existing.receivers.some(
                              (r) => r.isAdditionalReceiver
                          )
                        : false,
                    itemGuid: productDetails.existing.itemGuid,
                    baseProductId: productDetails.baseProductId,
                    partNumber: productDetails.existing.partNumber,
                    orderType:
                        productDetails.existing.orderType ===
                        intl.formatMessage({
                            id: 'Patient_Order',
                            defaultMessage: 'Patient Order',
                        })
                            ? 'patient'
                            : 'bulk',
                    quantity:
                        productDetails.existing.orderType ===
                        intl.formatMessage({
                            id: 'Patient_Order',
                            defaultMessage: 'Patient Order',
                        })
                            ? 0
                            : parseInt(
                                  productDetails.existing.quantity.toString()
                              ),
                    side:
                        productDetails.existing.side === 'Binaural'
                            ? 'B'
                            : productDetails.existing.side === 'Right'
                            ? 'R'
                            : productDetails.existing.side === 'Left' &&
                              productDetails.existing.orderType ===
                                  intl.formatMessage({
                                      id: 'Patient_Order',
                                      defaultMessage: 'Patient Order',
                                  })
                            ? 'L'
                            : null,
                    cartItemTypeId: productDetails.existing.cartItemTypeId,
                    catalogId: productDetails.catalogId,
                    earmoldCategory: productDetails.earmoldCategory,
                    existingItemId: productDetails.existing.itemID,
                    isCustom: productDetails.isCustom,
                    pageGuid: productDetails.pageGuid,
                    selectedImage: productDetails.existing.imageUrl,
                    selectedColor: productDetails.existing.color,
                    selectedItemNumber: productDetails.existing.partNumber,
                    designId: productDetails.designId,
                    productUrl: productDetails.url,
                    description: productDetails.description,
                    brand: productDetails.brand,
                    ampQuantityLeft: 0,
                    patient: {
                        ...productDetails.existing.patient!,
                        id: null,
                        audiogram:
                            productDetails.existing.patient! &&
                            productDetails.existing.patient!.audiogram
                                ? productDetails.existing.patient!.audiogram
                                : JSON.stringify({
                                      right: {
                                          air: { curve: ',,,,,,,,,' },
                                          bone: { curve: ',,,,,,,,,' },
                                          MCL: null,
                                          UCL: null,
                                      },
                                      left: {
                                          air: { curve: ',,,,,,,,,' },
                                          bone: { curve: ',,,,,,,,,' },
                                          MCL: null,
                                          UCL: null,
                                      },
                                      MCL: null,
                                      UCL: null,
                                  }),
                    },
                    receivers:
                        productDetails.existing.patient! && productDetails.cros
                            ? null
                            : getExistingReceivers(
                                  cloned.existing.receivers,
                                  isMiracleEar(session!.siteNumber),
                                  productDetails.existing.orderType ===
                                      intl.formatMessage({
                                          id: 'Patient_Order',
                                          defaultMessage: 'Patient Order',
                                      })
                                      ? 'patient'
                                      : 'bulk'
                              ),
                    accessories: cloned.existing.accessories,
                    thinTubes: cloned.existing.thinTubes,
                    showSpecialInstructions:
                        productDetails.existing.specialInstructions &&
                        productDetails.existing.specialInstructions !== ''
                            ? true
                            : false,
                    specialInstructions:
                        productDetails.existing.specialInstructions,
                    cros: productDetails.cros,
                    pairAid: getExistingCrosPairAid(),
                    warranty: productDetails.existing.warranty,
                    earmoldDesignId: productDetails.existing.earmoldDesignId!,
                    receiverFit: [
                        CartItemTypes.BteOnly,
                        CartItemTypes.RicWithStockReceiver,
                    ].includes(productDetails.existing.cartItemTypeId!)
                        ? receiverFitTypes.standard
                        : [
                              CartItemTypes.BteWithEarmold,
                              CartItemTypes.RicWithEarmold,
                          ].includes(productDetails.existing.cartItemTypeId!)
                        ? receiverFitTypes.earmold
                        : [CartItemTypes.RicWithAp].includes(
                              productDetails.existing.cartItemTypeId!
                          )
                        ? receiverFitTypes.ap
                        : null,
                    impressions: productDetails.existing.patient
                        ? productDetails.existing.patient!.scanOnFileLeft ||
                          productDetails.existing.patient!.scanOnFileRight
                            ? 'Use digital impressions on file'
                            : productDetails.existing.patient!
                                  .otoscanPackageId1 ||
                              productDetails.existing.patient!.otoscanPackageId2
                            ? 'Direct ear scan'
                            : productDetails.existing.patient!.impressionLeft ||
                              productDetails.existing.patient!.impressionRight
                            ? 'Attach digital impressions'
                            : 'Send physical impressions'
                        : null,
                    ...stateResult.orderDetails,
                });
            } else {
                const transferPatient = parseTransferPatient(
                    cookies.transferPatient
                );
                const isAgreementOrder = agreementName.length > 0;
                const initialOrderType = getInitialOrderType(
                    !!transferPatient,
                    isAgreementOrder
                );
                const newOrderState = {
                    itemGuid: productDetails.itemGuid,
                    baseProductId: productDetails.baseProductId,
                    partNumber: productDetails.partNumber,
                    orderType: initialOrderType,
                    quantity: 1,
                    side: initialOrderType === 'patient' ? 'B' : null,
                    cartItemTypeId: productDetails.cartItemTypeId,
                    earmoldCategory: productDetails.earmoldCategory,
                    catalogId: productDetails.catalogId,
                    existingItemId: '-1',
                    isCustom: productDetails.isCustom,
                    pageGuid: productDetails.pageGuid,
                    selectedImage:
                        customDefaultImageUrl || productDetails.imageUrl,
                    selectedColor: productDetails.defaultColor,
                    selectedItemNumber: productDetails.partNumber,
                    designId: productDetails.designId,
                    productUrl: productDetails.url,
                    description: productDetails.description,
                    brand: productDetails.brand,
                    patient: getInitialPatient(
                        transferPatient,
                        patientDetails,
                        isAgreementOrder
                    ),
                    receiverFit: receiverFitTypes.standard,
                    receivers:
                        initialOrderType === 'patient'
                            ? null
                            : [CartItemTypes.RicWithStockReceiver].includes(
                                  productDetails!.cartItemTypeId!
                              ) &&
                              productDetails!.options.find((x) => x.id === 19)
                            ? [
                                  {
                                      ...receiver!,
                                      useAngledParts: true,
                                      quantity: 1,
                                  },
                              ]
                            : null,
                    accessories: [],
                    thinTubes: [],
                    showSpecialInstructions: false,
                    specialInstructions: null,
                    cros: productDetails.cros,
                    warranty: 0,
                };

                setOrderState({
                    ...orderState!,
                    ...newOrderState,
                    ...stateResult.orderDetails!,
                });
            }
        }
        if (productDetails) {
            setGainInfo(
                productDetails.options?.find((x) => x.id === 19)?.items[0]
                    ?.items
            );
            setCableInfo(
                productDetails.options?.find((x) => x.id === 8)?.items[0]?.items
            );
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productDetails && productDetails.itemGuid]);

    useEffect(() => {
        if (productDetailState.isCustom) {
            prepareFaceplatesAndShells(productDetailState.options);
        }
    }, [productDetailState.isCustom, productDetailState.options]);

    useEffect(() => {
        if (Object.keys(errorsState).length > 0) {
            const errors = IsValid(
                orderState,
                productDetailState,
                patientNumberRequired,
                session.country,
                false,
                session.siteNumber,
                intl
            );
            setErrorsState(errors);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderState]);
    useEffect(() => {
        if (
            orderState.earmoldCategory &&
            orderState.patient &&
            orderState.patient.ageRange === 'Under 18'
        ) {
            setShowModal((prevState) => ({
                ...prevState,
                under18: true,
            }));
        }
        if (cableLengthHook(orderState)) {
            setShowModal((prevState) => ({
                ...prevState,
                cableLength: true,
            }));
        }
    }, [orderState]);

    useEffect(() => {
        if (
            !CON.impressionsCartItemTypes.includes(
                orderState!.cartItemTypeId!
            ) &&
            orderState.patient
        ) {
            const {
                leftLoss,
                rightLoss,
                scanOnFileLeft,
                scanOnFileRight,
                leftImpressionFileName,
                rightImpressionFileName,
                impressionRight,
                impressionLeft,
                otoscanPackageId1,
                otoscanPackageId2,
                ...patientTrimmed
            } = orderState.patient;
            setOrderState((prevState) => ({
                ...prevState!,
                impressions: null,
                patient: patientTrimmed as IPatient,
            }));
        }
    }, [orderState.cartItemTypeId]);

    //#endregion

    return (
        <>
            <TransferPatientAlert />
            <div className="container">
                {productDetails &&
                    Object.keys(productDetailState).length > 0 &&
                    Object.keys(orderState).length > 0 && (
                        <form
                            onSubmit={addItemToCart}
                            style={{ marginBottom: '60px' }}
                            noValidate={true}
                        >
                            <div className="row row-m-b">
                                <div className="col-md-8">
                                    <div className="row row-m-b">
                                        <h2
                                            className="col-md-12 no-text-transform"
                                            id="product-details-product-name"
                                        >
                                            {intl.formatMessage({
                                                id: productDetails.description
                                                    .split(' ')
                                                    .join('_'),
                                                defaultMessage:
                                                    productDetails.description,
                                            })}
                                        </h2>
                                    </div>
                                    <div
                                        className="row row-m-b"
                                        style={{ fontSize: '20px' }}
                                    >
                                        <div className="col-md-6">
                                            {![
                                                CartItemTypes.ApReceiver,
                                                CartItemTypes.Earmold,
                                                CartItemTypes.CustomOnly,
                                                CartItemTypes.SoundGearCustom,
                                                CartItemTypes.SoundGearEarmold,
                                            ].includes(
                                                orderState.cartItemTypeId!
                                            ) && (
                                                <span id="product-details-part-number">
                                                    {intl.formatMessage({
                                                        id: 'Part_#',
                                                        defaultMessage:
                                                            'Part #',
                                                    })}{' '}
                                                    {orderState.partNumber}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row row-m-b">
                                        <div className="col-md-12">
                                            <LongDescription
                                                description={
                                                    productDetailState!
                                                        .longDescription
                                                }
                                            />
                                        </div>
                                    </div>

                                    {[9189, 9195].includes(
                                        productDetailState.designId
                                    ) &&
                                        !isMiracleEar(session.siteNumber) &&
                                        session.country === CON.US && (
                                            <div className="row row-m-b">
                                                <div className="col-md-12">
                                                    <FormattedMessage
                                                        id="Custom_Cased_Charger"
                                                        defaultMessage="The Starlink Charger (not the Mini Premium) is recommended with Custom Cased receivers to allow for space for the earmold."
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    {hasColorOptions() &&
                                        !isMiracleEar(session.siteNumber) && (
                                            <ColorSection
                                                productDetailState={
                                                    productDetailState
                                                }
                                                productHoverImage={
                                                    productHoverImage
                                                }
                                                orderState={orderState}
                                                faceplates={faceplates}
                                                shells={shells}
                                                onHover={
                                                    handleFacePlateImageHover
                                                }
                                                onChange={
                                                    handleStateResultChange
                                                }
                                            />
                                        )}
                                    {[
                                        CartItemTypes.Earmold,
                                        CartItemTypes.SoundGearEarmold,
                                    ].includes(
                                        productDetailState!.cartItemTypeId!
                                    ) && (
                                        <EarmoldStyleSelection
                                            orderState={orderState!}
                                            earmoldsTypes={
                                                productDetailState!.earmolds.find(
                                                    (x) =>
                                                        x.key ===
                                                        orderState!
                                                            .earmoldCategory
                                                )!.items
                                            }
                                            noteHtml={
                                                productDetailState!.earmolds.find(
                                                    (x) =>
                                                        x.key ===
                                                        orderState!
                                                            .earmoldCategory
                                                )!.noteHtml
                                            }
                                            onChange={handleChange}
                                            errors={errorsState}
                                        />
                                    )}
                                    {session.country === CON.US &&
                                        productDetailState.earmoldCategory ===
                                            CON.earmoldCategory.Specialty && (
                                            <Alert
                                                message={
                                                    'Specialty earmolds will now be a part of the SoundGear family! In order to provide patients with the most robust product experience, specialty earmolds will now come with SoundGear branded materials, manuals, and cases. Please continue to use this page to place your order.'
                                                }
                                                type={CON.BS.Info}
                                                translationId={
                                                    'Specialty_Earmold_Message'
                                                }
                                            />
                                        )}
                                    {session.country === CON.US &&
                                        productDetailState.earmoldCategory ===
                                            CON.earmoldCategory.Earplug && (
                                            <Alert
                                                message={
                                                    'Many Starkey Earplug Earmolds are now a part of the SoundGear family! Please visit the SoundGear Passive Hearing Protection page to order: Solid Earplugs, Musician Mini Filter Earplugs, and High Frequency Noise Filter Earplugs. '
                                                }
                                                type={CON.BS.Info}
                                                translationId={
                                                    'Earplug_Earmold_Message'
                                                }
                                            />
                                        )}
                                    {/*Temporarily removed until we get updates from business*/}
                                    {/* <div className="row">
                                        <div
                                            className="col-md-12"
                                            style={{ zIndex: 1 }}
                                        >
                                            {productDetailState!
                                                .inventoryStatuses &&
                                                productDetailState!
                                                    .inventoryStatuses.length >
                                                    0 && (
                                                    <>
                                                        {productDetailState!.inventoryStatuses
                                                            .filter(
                                                                s =>
                                                                    s.partNumber ===
                                                                    productDetailState.partNumber
                                                            )
                                                            .map(x => {
                                                                return (
                                                                    <h4
                                                                        style={{
                                                                            color:
                                                                                x.statusColor
                                                                        }}
                                                                        key={
                                                                            x.status
                                                                        }
                                                                    >
                                                                        <i className="fad fa-check" />{' '}
                                                                        {
                                                                            x.statusText
                                                                        }
                                                                    </h4>
                                                                );
                                                            })}
                                                    </>
                                                )}
                                        </div>
                                    </div> */}
                                </div>
                                <div className="col-md-4">
                                    <ImageSection
                                        productDetailState={productDetailState}
                                        productHoverImage={productHoverImage}
                                        orderState={orderState}
                                        session={session!}
                                        top={true}
                                    />

                                    <div className="row">
                                        <div>
                                            <button
                                                id="product-details-favorite-btn"
                                                type="button"
                                                className="btn-link"
                                                onClick={() =>
                                                    handleToggleFavorite(
                                                        productId
                                                    )
                                                }
                                            >
                                                {isFavorite(productId) ? (
                                                    <>
                                                        <i
                                                            className={
                                                                'fas fa-star fa-lg'
                                                            }
                                                        />{' '}
                                                        {intl.formatMessage({
                                                            id: 'Favorite',
                                                            defaultMessage:
                                                                'Favorite',
                                                        })}
                                                    </>
                                                ) : (
                                                    <>
                                                        <i
                                                            className={
                                                                'far fa-star fa-lg'
                                                            }
                                                        />{' '}
                                                        {intl.formatMessage({
                                                            id: 'Add_to_Favorites',
                                                            defaultMessage:
                                                                'Add to Favorites',
                                                        })}
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {Object.keys(errorsState).length > 0 && (
                                <RowElementWrapper>
                                    <div ref={errorRef}>
                                        <ErrorsMessageBox
                                            errors={errorsState}
                                        />
                                    </div>
                                </RowElementWrapper>
                            )}
                            {/* Product Order Info Section Start */}
                            {agreementName.length === 0 &&
                                !isSoundGearProduct &&
                                ![
                                    CartItemTypes.CustomOnly,
                                    CartItemTypes.ApReceiver,
                                    CartItemTypes.Earmold,
                                    CartItemTypes.SoundGearEarmold,
                                    CartItemTypes.SoundGearCustom,
                                ].includes(
                                    productDetailState!.cartItemTypeId!
                                ) && (
                                    <>
                                        <div className="row row-m-b">
                                            <div className="col-md-12">
                                                <h2 className="no-text-transform">
                                                    {intl.formatMessage({
                                                        id: 'Is_this_for_a_patient',
                                                        defaultMessage:
                                                            'Is this for a patient?',
                                                    })}
                                                </h2>
                                            </div>
                                        </div>
                                        <div className="row row-m-b">
                                            <div className="col-md-12">
                                                <SelectButton
                                                    name="orderType"
                                                    selectedOption={
                                                        orderState!.orderType
                                                    }
                                                    options={yesNo.map((x) => {
                                                        return {
                                                            value: x.value
                                                                ? 'patient'
                                                                : 'bulk',
                                                            text: intl.formatMessage(
                                                                {
                                                                    id: x.text,
                                                                    defaultMessage:
                                                                        x.text,
                                                                }
                                                            ),
                                                        };
                                                    })}
                                                    // TODO: Move to handle change event.
                                                    onChange={(e) =>
                                                        handleChange(
                                                            e.target.name,
                                                            e.target.value
                                                        )
                                                    }
                                                    width="300px"
                                                    isProductOptions={false}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                            {session &&
                                !isSoundGearProduct &&
                                agreementDisplayCheck(session) && (
                                    <div
                                        className="row row-m-b"
                                        style={{
                                            display: 'flex',
                                            margin: '10px 0px',
                                            border: '2px solid #1e9be9',
                                            maxWidth: '642px',
                                        }}
                                    >
                                        <div
                                            className="col-md-8"
                                            style={{
                                                alignItems: 'center',
                                                padding: '3%',
                                            }}
                                        >
                                            {orderState &&
                                            orderState.patient &&
                                            orderState.patient.agreementType ? (
                                                <span>
                                                    {orderState.patient
                                                        .agreementInfo ? (
                                                        orderState.patient
                                                            .agreementType +
                                                        ': ' +
                                                        orderState.patient
                                                            .agreementInfo
                                                    ) : (
                                                        <>
                                                            {
                                                                orderState
                                                                    .patient
                                                                    .agreementType
                                                            }
                                                        </>
                                                    )}
                                                </span>
                                            ) : (
                                                <span>
                                                    {intl.formatMessage({
                                                        id: `No_state-fund_or_benefit`,
                                                        defaultMessage: `No state-fund or benefit
                                                    selected.`,
                                                    })}
                                                </span>
                                            )}
                                        </div>
                                        <div
                                            className="col-md-4"
                                            style={{
                                                padding: '10px',
                                            }}
                                        >
                                            <Link
                                                to={
                                                    '/estore/product-list?' +
                                                    HEARING_AIDS_URL_PARAMS
                                                }
                                                id="product-details-benefit-change-link"
                                                className="btn btn-primary pull-right"
                                            >
                                                {intl.formatMessage({
                                                    id: 'Change_Selection',
                                                    defaultMessage:
                                                        'Change Selection',
                                                })}
                                            </Link>
                                        </div>
                                    </div>
                                )}

                            {orderState!.orderType === 'patient' && (
                                <>
                                    <PatientSection
                                        patientDetails={orderState.patient!}
                                        updatePatientDetailsOnOrder={
                                            updatePatientDetails
                                        }
                                        isCustom={productDetailState!.isCustom}
                                        isPatientNumberRequired={
                                            patientNumberRequired
                                        }
                                        orderDetails={orderState!}
                                        errors={errorsState}
                                        countryCode={session.country}
                                        session={session!}
                                    />
                                </>
                            )}
                            {!productDetails.isCustom &&
                                orderState!.orderType !== 'patient' && (
                                    <div>
                                        <div className="row row-m-b">
                                            <div className="col-md-12">
                                                <h2 className="no-text-transform">
                                                    {intl.formatMessage({
                                                        id: 'Choose_Quantity',
                                                        defaultMessage:
                                                            'Choose Quantity',
                                                    })}
                                                </h2>
                                            </div>
                                        </div>
                                        {displayReceiverGuide && (
                                            <ReceiverPDFGuide
                                                selectedBrand={
                                                    session.selectedBrand
                                                }
                                            />
                                        )}
                                        <div className="row row-m-b">
                                            <div className="col-md-12">
                                                <TextInput
                                                    name="quantitySelection"
                                                    label={'Quantity'}
                                                    value={orderState!.quantity}
                                                    onChange={(e) => {
                                                        e.persist();
                                                        setOrderState(
                                                            (prevState) => ({
                                                                ...prevState!,
                                                                quantity:
                                                                    parseInt(
                                                                        e.target
                                                                            .value
                                                                    ),
                                                            })
                                                        );
                                                    }}
                                                    fieldClassName="col-sm-3"
                                                    labelClassName="col-sm-12"
                                                    customLabel={true}
                                                    toolTipMessage={
                                                        isSoundGearTooltip
                                                            ? intl.formatMessage(
                                                                  {
                                                                      id: 'Quantity_Tooltip',
                                                                      defaultMessage:
                                                                          'Quantity 1 = Pair of devices',
                                                                  }
                                                              )
                                                            : undefined
                                                    }
                                                    error={errorsState.quantity}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            {orderState!.orderType === 'patient' && (
                                <div>
                                    <div className="row row-m-b">
                                        <div className="col-md-12">
                                            <h2 className="no-text-transform">
                                                {intl.formatMessage({
                                                    id: 'Choose_Fit_Options',
                                                    defaultMessage:
                                                        'Choose Fit Options',
                                                })}
                                            </h2>
                                        </div>
                                    </div>
                                    <div className="row row-m-b">
                                        <div className="col-md-12">
                                            <SelectButton
                                                name="side"
                                                selectedOption={orderState.side}
                                                label={intl.formatMessage({
                                                    id: 'Ear',
                                                    defaultMessage: 'Ear',
                                                })}
                                                options={[
                                                    productDetailState!.isCros
                                                        ? 'CROS System'
                                                        : 'Binaural',
                                                    'Right Ear Only',
                                                    'Left Ear Only',
                                                ].map((x) => {
                                                    return {
                                                        value:
                                                            x === 'Binaural' ||
                                                            x === 'CROS System'
                                                                ? 'B'
                                                                : x ===
                                                                  'Left Ear Only'
                                                                ? 'L'
                                                                : 'R',
                                                        text: intl.formatMessage(
                                                            {
                                                                id: x.replace(
                                                                    / /g,
                                                                    '_'
                                                                ),
                                                                defaultMessage:
                                                                    x,
                                                            }
                                                        ),
                                                    };
                                                })}
                                                onChange={(e) => {
                                                    handleChange(
                                                        e.target.name,
                                                        e.target.value
                                                    );
                                                }}
                                                isProductOptions={false}
                                            />
                                            {[
                                                CartItemTypes.BteOnly,
                                                CartItemTypes.BteWithEarmold,
                                                CartItemTypes.RicWithStockReceiver,
                                                CartItemTypes.RicWithEarmold,
                                                CartItemTypes.RicWithAp,
                                            ].includes(
                                                orderState!.cartItemTypeId!
                                            ) && (
                                                <SelectButton
                                                    name="receiverFit"
                                                    selectedOption={
                                                        orderState!.receiverFit
                                                    }
                                                    label={
                                                        [
                                                            CartItemTypes.BteOnly,
                                                            CartItemTypes.BteWithEarmold,
                                                        ].includes(
                                                            orderState!
                                                                .cartItemTypeId!
                                                        )
                                                            ? ''
                                                            : intl.formatMessage(
                                                                  {
                                                                      id: 'Receiver_Fit',
                                                                      defaultMessage:
                                                                          'Receiver Fit',
                                                                  }
                                                              )
                                                    }
                                                    options={getReceiverFit(
                                                        session.country,
                                                        productDetailState
                                                    ).map((x) => {
                                                        return {
                                                            value: x,
                                                            text: intl.formatMessage(
                                                                {
                                                                    id: getCustomCaseName(
                                                                        x
                                                                    ),

                                                                    defaultMessage:
                                                                        x,
                                                                }
                                                            ),
                                                        };
                                                    })}
                                                    // TODO: move to handle change.
                                                    onChange={(e) => {
                                                        handleChange(
                                                            'receiverFit',
                                                            e.target.value
                                                        );
                                                    }}
                                                    isProductOptions={false}
                                                    isReceiverFit={true}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {orderState &&
                                orderState.cros &&
                                orderState.side !== 'B' &&
                                orderState.orderType === 'patient' && (
                                    <RowElementWrapper>
                                        <SerialNumberLookup
                                            name={'crosPair'}
                                            onChange={(serialNumber) =>
                                                updatePatientData(
                                                    'crosPair',
                                                    serialNumber
                                                )
                                            }
                                            productStyle={
                                                productDetailState!.style
                                            }
                                            error={errorsState.crosPair}
                                        />
                                    </RowElementWrapper>
                                )}
                            {orderState!.orderType === 'bulk' &&
                                gainInfo &&
                                cableInfo && (
                                    <div>
                                        <div className="row row-m-b">
                                            <div className="col-md-12">
                                                <h4 className="no-text-transform">
                                                    {intl.formatMessage({
                                                        id: 'Receiver',
                                                        defaultMessage:
                                                            'Receiver',
                                                    })}
                                                </h4>
                                            </div>
                                            <div className="col-md-12 col-sm-12">
                                                <ReceiversSelect
                                                    productState={
                                                        productDetails
                                                    }
                                                    gains={gainInfo}
                                                    cables={cableInfo}
                                                    receivers={
                                                        orderState!.receivers!
                                                    }
                                                    quantity={
                                                        orderState!.quantity
                                                    }
                                                    updateReceivers={
                                                        updateReceivers
                                                    }
                                                    orderState={orderState!}
                                                    receiver={receiver!}
                                                    errors={errorsState}
                                                    countryCode={
                                                        session.country
                                                    }
                                                    isAdd={false}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                            {CON.impressionsCartItemTypes.includes(
                                orderState!.cartItemTypeId!
                            ) && (
                                <>
                                    <div>
                                        <RowElementWrapper>
                                            <h2 className="no-text-transform">
                                                {intl.formatMessage({
                                                    id: 'Send_Impressions',
                                                    defaultMessage:
                                                        'Send Impressions',
                                                })}
                                                <span
                                                    className="required"
                                                    style={{
                                                        position: 'inherit',
                                                    }}
                                                />
                                            </h2>
                                        </RowElementWrapper>

                                        <RowElementWrapper>
                                            <ImpressionsSection
                                                orderDetails={orderState}
                                                country={session.country}
                                                updatePatient={
                                                    updatePatientDetails
                                                }
                                                onChange={(e) =>
                                                    handleChange(
                                                        e.target.name,
                                                        e.target.value
                                                    )
                                                }
                                                siteNumber={session.siteNumber}
                                                errors={errorsState}
                                            />
                                        </RowElementWrapper>
                                    </div>
                                </>
                            )}
                            {([
                                CartItemTypes.CustomOnly,
                                CartItemTypes.BteWithEarmold,
                                CartItemTypes.RicWithEarmold,
                                CartItemTypes.RicWithAp,
                                CartItemTypes.ApReceiver,
                            ].includes(orderState!.cartItemTypeId!) ||
                                [
                                    'RIC Earmold',
                                    'Standard Earmold',
                                    'Thin Tube Earmold',
                                ].includes(
                                    productDetailState!.earmoldCategory
                                )) && (
                                <div>
                                    <RowElementWrapper>
                                        <h2 className="no-text-transform">
                                            {intl.formatMessage({
                                                id: 'Audiogram',
                                                defaultMessage: 'Audiogram',
                                            })}
                                        </h2>
                                    </RowElementWrapper>
                                    <RowElementWrapper>
                                        <ThresholdSection
                                            selectedSide={orderState!.side!}
                                            patientDetails={
                                                orderState!.patient!
                                            }
                                            onChange={updatePatientDetails}
                                            productDetails={productDetailState!}
                                            updateStarkeyChoiceOrHearingLoss={
                                                updateStarkeyChoiceOrHearingLoss
                                            }
                                            errors={errorsState}
                                        />
                                    </RowElementWrapper>
                                </div>
                            )}
                            {productDetailState!.options &&
                                findOption(
                                    'Starkey Choice',
                                    productDetailState!.options
                                ) && (
                                    <>
                                        <RowElementWrapper>
                                            <h2 className="no-text-transform">
                                                {intl.formatMessage({
                                                    id: 'Custom_Options',
                                                    defaultMessage:
                                                        'Custom Options',
                                                })}
                                            </h2>
                                        </RowElementWrapper>
                                        <RowElementWrapper>
                                            <h3 className="no-text-transform">
                                                {intl.formatMessage({
                                                    id: CON.MANUFACTURER_SELECT_ID,
                                                    defaultMessage:
                                                        CON.MANUFACTURER_SELECT,
                                                })}
                                            </h3>
                                            <RowElementWrapper>
                                                <StarkeyChoice
                                                    options={
                                                        findOption(
                                                            'Starkey Choice',
                                                            productDetailState!
                                                                .options
                                                        )!.items
                                                    }
                                                    selectedIds={{
                                                        rightSelectedIds:
                                                            orderState!
                                                                .rightSelectedIds,
                                                        leftSelectedIds:
                                                            orderState!
                                                                .leftSelectedIds,
                                                    }}
                                                    onChange={
                                                        handleOptionsChange
                                                    }
                                                    side={orderState!.side!}
                                                />
                                            </RowElementWrapper>
                                            {hasLargerStyle() && (
                                                <RowElementWrapper>
                                                    <LargerStyle
                                                        selectedIds={{
                                                            rightSelectedIds:
                                                                orderState!
                                                                    .rightSelectedIds,
                                                            leftSelectedIds:
                                                                orderState!
                                                                    .leftSelectedIds,
                                                        }}
                                                        onChange={
                                                            handleOptionsChange
                                                        }
                                                        side={orderState!.side!}
                                                    />
                                                </RowElementWrapper>
                                            )}
                                        </RowElementWrapper>
                                    </>
                                )}
                            {/* Product Order Info Section End */}
                            {/* Product Options Section Start */}
                            {productDetailState!.options &&
                                productDetailState!.options.length > 0 && (
                                    <>
                                        <RowElementWrapper>
                                            <h2 className="no-text-transform">
                                                {intl.formatMessage({
                                                    id: 'Product_Options',
                                                    defaultMessage:
                                                        'Product Options',
                                                })}
                                            </h2>
                                        </RowElementWrapper>
                                        {isMiracleEar(session.siteNumber) && (
                                            <RowElementWrapper>
                                                <div className="col-md-8">
                                                    <ColorSection
                                                        productDetailState={
                                                            productDetailState
                                                        }
                                                        productHoverImage={
                                                            productHoverImage
                                                        }
                                                        orderState={orderState}
                                                        faceplates={faceplates}
                                                        shells={shells}
                                                        onHover={
                                                            handleFacePlateImageHover
                                                        }
                                                        onChange={
                                                            handleStateResultChange
                                                        }
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <ImageSection
                                                        productDetailState={
                                                            productDetailState
                                                        }
                                                        productHoverImage={
                                                            productHoverImage
                                                        }
                                                        orderState={orderState}
                                                        session={session!}
                                                        top={false}
                                                    />
                                                </div>
                                            </RowElementWrapper>
                                        )}

                                        <RowElementWrapper>
                                            <ProductOptions
                                                options={
                                                    productDetailState!.options
                                                }
                                                productDetails={
                                                    productDetailState!
                                                }
                                                orderDetails={orderState!}
                                                updateSelectedOptions={
                                                    handleOptionsChange
                                                }
                                                isEarmold={false}
                                                updateCrosPairAid={(pairAid) =>
                                                    setOrderState(
                                                        (prevState) => ({
                                                            ...prevState!,
                                                            pairAid: pairAid
                                                                ? pairAid
                                                                : null,
                                                        })
                                                    )
                                                }
                                                errors={errorsState}
                                                onAddDeleteAccessory={
                                                    handleAddDeleteAccessory
                                                }
                                                selectedAccessories={
                                                    orderState!.accessories
                                                }
                                                patientOrder={
                                                    orderState.orderType ===
                                                    'patient'
                                                }
                                                isUpdateDetails={false}
                                            />
                                        </RowElementWrapper>
                                    </>
                                )}
                            {/* Product Options Section End */}

                            {/* Earmold Options Section Start */}
                            {(([
                                CartItemTypes.BteWithEarmold,
                                CartItemTypes.RicWithEarmold,
                            ].includes(orderState!.cartItemTypeId!) &&
                                productDetailState!.earmolds) ||
                                ([
                                    CartItemTypes.Earmold,
                                    CartItemTypes.SoundGearEarmold,
                                ].includes(orderState!.cartItemTypeId!) &&
                                    orderState!.earmoldDesignId)) && (
                                <>
                                    <RowElementWrapper>
                                        <h2 className="no-text-transform">
                                            {intl.formatMessage({
                                                id: 'Earmold_Options',
                                                defaultMessage:
                                                    'Earmold Options',
                                            })}
                                        </h2>
                                    </RowElementWrapper>
                                    <RowElementWrapper>
                                        <EarmoldOptions
                                            earmolds={
                                                productDetailState!.earmolds
                                            }
                                            productDetails={productDetailState}
                                            orderDetails={orderState!}
                                            onChange={handleChange}
                                            session={session}
                                            updateSelectedOptions={
                                                handleOptionsChange
                                            }
                                            // TODO: fix this update chain
                                            updateOptionsOnProductDetailState={(
                                                options,
                                                isEarmold
                                            ) => {
                                                handleOptionsChange(
                                                    productDetailState.existing
                                                        ? orderState.rightEarmoldIds
                                                        : [],
                                                    productDetailState.existing
                                                        ? orderState.leftEarmoldIds
                                                        : [],
                                                    isEarmold,
                                                    options
                                                );
                                            }}
                                            updateCrosPairAid={(pairAid) =>
                                                handleChange(
                                                    'pairAid',
                                                    pairAid ? pairAid : null
                                                )
                                            }
                                            errors={errorsState}
                                        />
                                    </RowElementWrapper>
                                </>
                            )}
                            {/* Earmold Options Section End */}
                            {CartItemTypes.RicWithStockReceiver ===
                                orderState!.cartItemTypeId! &&
                                gainInfo &&
                                cableInfo &&
                                isMiracleEar(session!.siteNumber) &&
                                orderState.orderType === 'patient' &&
                                !orderState.cros && (
                                    <>
                                        <div className="row row-m-b">
                                            <div className="col-md-12">
                                                <h2 className="no-text-transform">
                                                    {intl.formatMessage({
                                                        id: 'Would You Like To Purchase Additional Receivers',
                                                        defaultMessage:
                                                            'Would You Like To Purchase Additional Receivers',
                                                    })}
                                                </h2>
                                            </div>
                                            <div className="row row-m-b">
                                                <div className="col-md-12">
                                                    <SelectButton
                                                        name="additionalReceivers"
                                                        selectedOption={
                                                            orderState.additionalReceivers
                                                                ? 'true'
                                                                : 'false'
                                                        }
                                                        options={yesNo.map(
                                                            (x) => {
                                                                return {
                                                                    value: x.value.toString(),
                                                                    text: intl.formatMessage(
                                                                        {
                                                                            id: x.text,
                                                                            defaultMessage:
                                                                                x.text,
                                                                        }
                                                                    ),
                                                                };
                                                            }
                                                        )}
                                                        isProductOptions={false}
                                                        isNonUnique={true}
                                                        onChange={(e) => {
                                                            handleChange(
                                                                'additionalReceivers',
                                                                e.target
                                                                    .value ===
                                                                    'true'
                                                                    ? true
                                                                    : false
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            {gainInfo &&
                                cableInfo &&
                                orderState.additionalReceivers && (
                                    <div>
                                        <div className="row row-m-b">
                                            <div className="col-md-12">
                                                <h4 className="no-text-transform">
                                                    {intl.formatMessage({
                                                        id: 'Receiver',
                                                        defaultMessage:
                                                            'Receiver',
                                                    })}
                                                </h4>
                                            </div>
                                            <div className="col-md-12 col-sm-12">
                                                <ReceiversSelect
                                                    productState={
                                                        productDetails
                                                    }
                                                    gains={gainInfo}
                                                    cables={cableInfo.filter(
                                                        (c) =>
                                                            c.english !==
                                                            'No Receiver'
                                                    )}
                                                    receivers={
                                                        orderState.receivers ===
                                                            null ||
                                                        orderState.receivers
                                                            .length === 0
                                                            ? [
                                                                  {
                                                                      ...receiver!,
                                                                      useAngledParts:
                                                                          true,
                                                                      quantity: 1,
                                                                  },
                                                              ]
                                                            : orderState.receivers
                                                    }
                                                    quantity={
                                                        orderState!.quantity
                                                    }
                                                    updateReceivers={
                                                        updateReceivers
                                                    }
                                                    orderState={orderState!}
                                                    receiver={receiver!}
                                                    errors={errorsState}
                                                    countryCode={
                                                        session.country
                                                    }
                                                    isAdd={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            {/* Product Related Items Section Start */}
                            {productDetails &&
                                ((productDetails.accessories &&
                                    productDetails.accessories.length > 0 &&
                                    productDetails.cartItemTypeId !==
                                        CartItemTypes.ApReceiver) ||
                                    (productDetails.commonSupplies &&
                                        productDetails.commonSupplies.length >
                                            0)) && (
                                    <div>
                                        <div className="row row-m-b">
                                            <div className="col-md-12">
                                                <h2 className="no-text-transform">
                                                    {intl.formatMessage({
                                                        id: 'You_may_need',
                                                        defaultMessage:
                                                            'You may need',
                                                    })}
                                                </h2>
                                            </div>
                                        </div>
                                        <div className="row row-m-b">
                                            {productDetails.accessories &&
                                                productDetails.accessories
                                                    .length > 0 &&
                                                productDetails.cartItemTypeId !==
                                                    CartItemTypes.ApReceiver && (
                                                    <RelatedItemsCarousel
                                                        label={intl.formatMessage(
                                                            {
                                                                id: 'Accessories',
                                                                defaultMessage:
                                                                    'Accessories',
                                                            }
                                                        )}
                                                        accessories={
                                                            productDetails.accessories
                                                        }
                                                        selectedAccessories={
                                                            orderState!
                                                                .accessories
                                                        }
                                                        onAddDeleteAccessory={
                                                            handleAddDeleteAccessory
                                                        }
                                                        patientOrder={
                                                            orderState.orderType ===
                                                            'patient'
                                                        }
                                                    />
                                                )}
                                            {productDetails.commonSupplies &&
                                                productDetails.commonSupplies
                                                    .length > 0 && (
                                                    <RelatedItemsCarousel
                                                        label={intl.formatMessage(
                                                            {
                                                                id: 'Common_Supplies',
                                                                defaultMessage:
                                                                    'Common_Supplies',
                                                            }
                                                        )}
                                                        accessories={
                                                            productDetails.commonSupplies
                                                        }
                                                        selectedAccessories={
                                                            orderState!
                                                                .accessories
                                                        }
                                                        onAddDeleteAccessory={
                                                            handleAddDeleteAccessory
                                                        }
                                                        patientOrder={
                                                            orderState.orderType ===
                                                            'patient'
                                                        }
                                                    />
                                                )}
                                        </div>
                                    </div>
                                )}
                            {/* Product Related Items Section End */}
                            {!!orderState &&
                                !isMiracleEar(session.siteNumber) &&
                                ![
                                    CartItemTypes.Earmold,
                                    CartItemTypes.SoundGear,
                                    CartItemTypes.SoundGearCustom,
                                    CartItemTypes.DashTailored,
                                    CartItemTypes.FacePlates,
                                ].includes(orderState.cartItemTypeId!) &&
                                !CON.noWarrantyCountries.includes(
                                    session.country
                                ) && (
                                    <WarrantySection
                                        name="WarrantySelection"
                                        selectedWarranty={orderState!.warranty}
                                        defaultWarranty={
                                            productDetails!.defaultWarranty
                                        }
                                        onChange={(e) => {
                                            e.persist();
                                            setOrderState((prevState) => ({
                                                ...prevState!,
                                                warranty: e.target.checked
                                                    ? parseInt(e.target.value)
                                                    : 0,
                                            }));
                                        }}
                                        showExtendedWarranty={
                                            ![
                                                CartItemTypes.Earmold,
                                                CartItemTypes.Accessory,
                                                CartItemTypes.SoundGearEarmold,
                                            ].includes(
                                                orderState!.cartItemTypeId!
                                            ) &&
                                            orderState.orderType === 'patient'
                                        }
                                        extendedWarranties={[1]}
                                        country={session.country}
                                    />
                                )}
                            <div className="add-to-cart-section">
                                {[
                                    CartItemTypes.CustomOnly,
                                    CartItemTypes.Earmold,
                                    CartItemTypes.BteWithEarmold,
                                    CartItemTypes.RicWithEarmold,
                                    CartItemTypes.RicWithAp,
                                    CartItemTypes.ApReceiver,
                                    CartItemTypes.SoundGearEarmold,
                                    CartItemTypes.SoundGearCustom,
                                    CartItemTypes.FacePlates,
                                ].includes(orderState!.cartItemTypeId!) && (
                                    <div className="row row-m-b">
                                        <div
                                            className="col-md-12"
                                            style={{
                                                textAlign: 'center',
                                            }}
                                        >
                                            <SpecialInstructions
                                                name={'specialInstructions'}
                                                orderDetails={orderState}
                                                showHideSpecialInstructions={(
                                                    show
                                                ) => {
                                                    handleChange(
                                                        'showSpecialInstructions',
                                                        show
                                                    );
                                                }}
                                                onChange={(e) => {
                                                    handleChange(
                                                        'specialInstructions',
                                                        e.target.value
                                                    );
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className="row row-m-b">
                                    <div className="col-md-8" />
                                    <div className="col-md-4">
                                        {/* {productDetailState!
                                            .inventoryStatuses &&
                                            productDetailState!
                                                .inventoryStatuses.length >
                                                0 && (
                                                <>
                                                    {productDetailState!.inventoryStatuses
                                                        .filter(
                                                            s =>
                                                                s.partNumber ===
                                                                productDetailState.partNumber
                                                        )
                                                        .map(x => {
                                                            return (
                                                                <h4
                                                                    style={{
                                                                        color:
                                                                            x.statusColor
                                                                    }}
                                                                    key={
                                                                        x.status
                                                                    }
                                                                >
                                                                    <i className="fad fa-check" />{' '}
                                                                    {
                                                                        x.statusText
                                                                    }
                                                                </h4>
                                                            );
                                                        })}
                                                </>
                                            )} */}

                                        {!productDetailState!.existing ? (
                                            <button
                                                className="btn btn-lg btn-primary"
                                                id="product-details-add-to-cart-btn"
                                            >
                                                {addingToCart
                                                    ? intl.formatMessage({
                                                          id: 'Adding',
                                                          defaultMessage:
                                                              'Adding',
                                                      }) + '...'
                                                    : intl.formatMessage({
                                                          id: 'Add_to_Cart',
                                                          defaultMessage:
                                                              'Add to Cart',
                                                      })}
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-lg btn-primary"
                                                id="product-details-save-to-cart-btn"
                                            >
                                                {addingToCart
                                                    ? intl.formatMessage({
                                                          id: 'Saving',
                                                          defaultMessage:
                                                              'Saving',
                                                      }) + '...'
                                                    : intl.formatMessage({
                                                          id: 'Save_Changes',
                                                          defaultMessage:
                                                              'Save Changes',
                                                      })}
                                            </button>
                                        )}
                                    </div>
                                    <div className="col-md-2" />
                                </div>
                            </div>
                        </form>
                    )}
            </div>
            {showModal.addToCart && (
                <MessageModal
                    onAccept={() => void 0}
                    cartItems={session!.carts.primary}
                    onClose={() => void 0}
                />
            )}
            {showModal.saveForLater && (
                <SavedForLaterModal
                    onAccept={saveToCart}
                    onClose={() =>
                        setShowModal((prevState) => ({
                            ...prevState,
                            saveForLater: false,
                        }))
                    }
                />
            )}
            {showModal.under18 && !showModal.isDismissed18 && (
                <Under18Modal
                    onAccept={() => undefined}
                    onClose={() => {
                        setShowModal((prevState) => ({
                            ...prevState,
                            under18: false,
                            isDismissed18: true,
                        }));
                    }}
                />
            )}
            {showModal.cableLength && !showModal.isDismissedCable && (
                <CableLengthModal
                    onAccept={() => undefined}
                    onClose={() => {
                        setShowModal((prevState) => ({
                            ...prevState,
                            cableLength: false,
                            isDismissedCable: true,
                        }));
                    }}
                />
            )}
        </>
    );
};

const mapStateToProps = (state: RootState, ownProps: any) => {
    const params = new URLSearchParams(ownProps.location.search);
    const cartId = params.get('c') || '';

    return {
        cartId,
        productId: ownProps.match.params.productId,
        productDetails: state.productDetails
            ? state.productDetails.data!
            : null,
        agreementName: params.get('agreementName') || '',
        agreementInfo: params.get('agreementInfo') || '',
        patientNumberRequired: JSON.parse(
            params.get('patientNumberRequired') || 'false'
        ),
        session: state.session!.data!,
        constants: state.constants,
        spaPath: state.spaPath,
    };
};

const mapDispatchToProps = {
    clearProductDetails,
    loadProductDetails,
    setIsBusy,
    loadConstants,
    loadSession,
    addToCart,
};

const productDetailContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ProductDetail);

export default productDetailContainer;
